import { useTermsLogic } from "../../Components/TermsLogic/TermsLogic";
import React from 'react';
import { getBrandName } from "../../Components/getBrandName";
import SEO from "../../../../SEO/Seo";
import { metaContent } from "../../../../SEO/metaContent";
const TermCondition = () => {
  const { brandName,mail,normalizedBrand,phone } = getBrandName();
  const { sections, generateContent } = useTermsLogic();

  return (<>
    {/* Meta tags  */}
    <SEO {...metaContent.termsCondition} />

    <div className="term-condition-page">
      <div className="term-condition-heading text-center">
        <h2 className="hero-heading text-white">Terms & Conditions</h2>
        <p className="text-muted" style={{ fontSize: "1.5rem" }}>Effective Date: <strong>July 3, 2025</strong></p>
      </div>

      <div className="privacy-container py-5">
        <div className="row">
          <div className="col-12">
            <p className='text-muted'>
              Welcome to {brandName} your trusted partner in e-commerce insights. These Terms & Conditions ("Terms") govern your access to and use of the {brandName} website, services, tools, and platform, whether as a visitor, registered user, or subscriber.
              <br />By accessing or using any part of our platform or services, you agree to comply with and be legally bound by these Terms. If you do not agree with any part of these Terms, do not use our services.
            </p>
            {sections.map((section) => (
              <div key={section.id} className="mb-0 mt-4">
                <h5 className="privacy-title">{section.title}</h5>
                <div className="text-muted">
                  {generateContent(section.id)}   
                </div>
              </div>
            ))}
            <div className="text-muted">
            <i className="bi bi-envelope-fill me-1"></i> {" "}
            <a href="mailto:${mail}" className="text-white text-decoration-none">
              {mail}
            </a>
            <br/>

            <i className="bi bi-telephone-fill me-1"></i> {" "}
            <a href="tel:${phone}" className="text-white text-decoration-none">
              {phone}
            </a>
            <br/>

            <i className="bi bi-globe me-1"></i> {" "}
            <a href="https://www.${normalizedBrand}.com" target="_blank" className="text-white text-decoration-none">
              www.{normalizedBrand}.com
            </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
};

export default TermCondition;
